import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Auth0Service } from '@geneplanet/ngx-auth0';
import { IntentStrategyService } from 'src/app/shared/services/intent/intent-strategy.service';

@Injectable({ providedIn: 'root' })
export class AccountsVerifiedGuard implements CanActivate, CanActivateChild {
  constructor(
    private readonly auth0: Auth0Service,
    private readonly intentStrategyService: IntentStrategyService
  ) {}

  canActivateChild(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> {
    return this.isActive(route);
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.isActive(route);
  }

  private isActive(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> {
    // Logic to skip onboarding steps - Questioner onboarding
    if (route.queryParams?.skip && !!JSON.parse(route.queryParams?.skip)) {
      return of(true);
    }

    return this.auth0.token$.pipe(
      switchMap((token) => {
        const account = new JwtHelperService().decodeToken(
          JSON.parse(token || '{}').idToken
        );

        if (!account) {
          return this.intentStrategyService.context.onUserNotExists();
        } else if (account?.email_verified) {
          return of(true);
          // Redirect to verify screen
        } else if (!account?.email_verified) {
          return this.intentStrategyService.context.onNotValidatedEmail();
        }
      })
    );
  }
}
